// Cei Endpoint information (connections and more)

const version = "2.2.8";

const PATH = process.env.VUE_APP_PATH;
const BASE_PATH = process.env.VUE_APP_BASE_PATH;
const RPT_PATH = process.env.VUE_APP_RPT_PATH;

export default {
    PATH,
    BASE_PATH,
    RPT_PATH,
    version,
}
